import { Helmet } from 'react-helmet-async';
import { PrivacyPageProps } from '../components/types';
import { Section } from '../components';
import { getPageMeta } from '../data';

export const Privacy: React.FC<PrivacyPageProps> = ({ content, lastUpdated }) => {
  const pageMeta = getPageMeta('/privacy');

  return (
    <>
      <Helmet>
        <title>{pageMeta?.title}</title>
        <meta name="description" content={pageMeta?.description} />
      </Helmet>

      <Section background="black" className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-black tracking-tight text-white mb-6 font-mono">
            Privacy Policy
          </h1>
          <div className="flex items-center space-x-2 text-sm text-gray-400 mb-16 font-mono border-b border-white/10 pb-8">
            <span className="text-gorillaGold">●</span>
            <span>Last updated: {lastUpdated}</span>
          </div>

          <div 
            className="prose prose-invert prose-lg max-w-none
              prose-headings:font-mono prose-headings:tracking-tight
              prose-h2:text-2xl prose-h2:font-bold prose-h2:text-white prose-h2:mt-16 prose-h2:mb-6
              prose-h3:text-xl prose-h3:font-bold prose-h3:text-white prose-h3:mt-10 prose-h3:mb-4
              prose-p:text-gray-300 prose-p:leading-relaxed prose-p:mb-6
              prose-ul:list-disc prose-ul:pl-6 prose-ul:text-gray-300 prose-ul:mb-8
              prose-li:mb-2 prose-li:marker:text-gorillaGold
              prose-strong:text-white prose-strong:font-bold
              prose-a:text-gorillaGold prose-a:no-underline hover:prose-a:text-white hover:prose-a:underline transition-colors"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </Section>
    </>
  );
};
